import {SakuraUIEnabledEnum} from '../types'
import {isSakuraEnabled} from '../utils/featureToggles'
import {UserProperties} from '../utils/userProperties'

import {useUserProperty} from './useUserProperty'

export function useIsSakuraSelected() {
  const isSakuraSelected = useUserProperty(UserProperties.USE_EXPERIMENTAL_OVERVIEW)

  switch (isSakuraEnabled) {
    case SakuraUIEnabledEnum.ENABLE_ALL:
      return true

    case SakuraUIEnabledEnum.ENABLE_DEFAULT:
      return isSakuraSelected !== 'false'

    case SakuraUIEnabledEnum.DISABLE_DEFAULT:
    default:
      return isSakuraSelected === 'true'
  }
}
